<template>
  <div class="insight-item">
    <div class="unit-head">
      <el-popover :content="description" width="250" placement="bottom-end" trigger="hover">
        <h5 slot="reference" class="unit-title">Reactions</h5>
      </el-popover>
    </div>
    <div v-if="reaction && reaction.total">
      <span v-for="(cfg, key) in reactionsMap" :key="key">
        <el-tooltip v-if="reaction[key]" :content="key">
          <el-badge :value="reaction[key] || 0" class="reaction">
            <emoji class="emoji-icon" :emoji="cfg.emoji" :set="emojiSet" :size="size"/>
          </el-badge>
        </el-tooltip>
      </span>
    </div>
    <div v-else class="no-reactions">None</div>
  </div>
</template>

<script>
/* eslint no-param-reassign: "off" */
import { Emoji } from 'emoji-mart-vue';

export default {
  data: () => ({
    size: 24,
    description:
      'The number of reactions your post received by reaction type (like, love, wow, haha, sad, anger).',
    emojiSet: 'emojione',
    reactionsMap: {
      like: {
        emoji: { id: 'thumbsup' },
      },
      love: {
        emoji: { id: 'heart_eyes' },
      },
      wow: {
        emoji: { id: 'astonished' },
      },
      haha: {
        emoji: { id: 'joy' },
      },
      anger: {
        emoji: { id: 'rage' },
      },
    },
  }),

  props: {
    reaction: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    Emoji,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/style/_variables_live.scss';
$my-text-color: #676a6c;

.insight-item {
  text-align: center;
  padding: 13px;
  margin: 3px auto;
}

.unit-head {
  color: $my-text-color;
  margin-bottom: 5px;
}

.reference {
  margin-left: 3px;
}

.unit-title {
  color: $colony-purple;
  display: inline;
}

.no-reactions {
  color: $my-text-color;
}

.reaction {
  margin: 8px;
}

.emoji-icon {
  margin: -3px;
}
</style>



// WEBPACK FOOTER //
// PostReactions.vue?9baed332